import App from "./App";
import React from "react";
import { store } from './app/store';
import { Provider } from 'react-redux';
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { checkLanguage } from "./app/language/Language";
store.dispatch(checkLanguage());

if (process.env.NODE_ENV !== "development") console.log = () => {};

ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);